import { render, staticRenderFns } from "./PhotographyExpandableImage.vue?vue&type=template&id=99c32b60&scoped=true"
import script from "./PhotographyExpandableImage.vue?vue&type=script&lang=ts"
export * from "./PhotographyExpandableImage.vue?vue&type=script&lang=ts"
import style0 from "./PhotographyExpandableImage.vue?vue&type=style&index=0&id=99c32b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c32b60",
  null
  
)

export default component.exports